/** Composer design options — Classic · Matrix · Rail. */

export const COMPOSER_VARIANTS = [{ id: 'classic', name: 'Ada', tagline: 'One quiet place to think' }];

/** Map retired ids so saved prefs / URLs keep working. */
export const LEGACY_COMPOSER_MAP = {
  // Strip / Ribbon + relatives → classic
  'v2-b': 'classic',
  'v3-b': 'classic',
  grid: 'classic',
  'grid-a': 'classic',
  'grid-b': 'classic',
  'grid-c': 'classic',
  'grid-e': 'classic',
  chips: 'classic',
  segments: 'classic',
  split: 'classic',
  'v2-a': 'classic',
  'v2-c': 'classic',
  'v2-d': 'classic',
  'v2-e': 'classic',
  'v3-a': 'classic',
  'v3-e': 'classic',
  // Matrix lineage (Focus D / Cells / prev-d / v3-d)
  'prev-d': 'matrix',
  'v3-d': 'matrix',
  'grid-d': 'matrix',
  // Rail lineage
  'v3-c': 'rail',
};

export const DEFAULT_COMPOSER_ID = 'classic';

/** Sentinel stored in localStorage when Auto (omit model) is selected. */
export const AUTO_MODEL_SENTINEL = '__auto__';

export function resolveComposerId(raw) {
  if (!raw) return DEFAULT_COMPOSER_ID;
  const mapped = LEGACY_COMPOSER_MAP[raw] || raw;
  if (COMPOSER_VARIANTS.some((v) => v.id === mapped)) return mapped;
  return DEFAULT_COMPOSER_ID;
}
